/*!
 * rdGFPDFEntries Scripts
 * @company Reactive Development LLC
 * @author Jeremy Selph <jselph@reactivedevelopment.net>
 * @link http://www.reactivedevelopment.net/
 * @version 0.1
 */ /**

    Change Log

     * 0.1  initial development by, Jeremy Selph                                                        2021/03/21
 
 */ /**
     * jquery onload
     * @author Jeremy Selph <jselph@reactivedevelopment.net>
     * @uses jquery.min.js
     * @version 0.1
    */
    jQuery( document ).ready(function() {
        
        jQuery( ".wpum-template .button" ).addClass( "button-primary" );

        /**
         * @author Jeremy Selph <jselph@reactivedevelopment.net>
         * @version 0.1
        */
        jQuery( ".rd_date_format .datepicker" ).change(function() {
            
            var temp = jQuery( this ).val();
            if ( temp.length > 0 && moment( temp, "MM-DD-YYYY" ).isValid() ){

                jQuery( this ).val( moment( temp, "MM-DD-YYYY" ).format( "MM/DD/YYYY" ) )

            }

        });

        /**
         * Gravity Wiz // Gravity Forms // Disable Submission when Pressing Enter 
         * http://gravitywiz.com/disable-submission-when-pressing-enter-for-gravity-forms/
         */
        jQuery(document).on( 'keypress', '.gform_wrapper', function (e) {
            var code = e.keyCode || e.which;
            if ( code == 13 && ! jQuery( e.target ).is( 'textarea,input[type="submit"],input[type="button"]' ) ) {
                e.preventDefault();
                return false;
            }
        } );

    });